import { IconButton } from "@similarweb/ui-components";
import type { ReactNode } from "react";

import { StyledButtonWrap, StyledModalHeader } from "./styles";

type ModalHeaderProps = {
    children: ReactNode;
    onReturn?(): void;
    onClose(): void;
};

const ModalHeader = (props: ModalHeaderProps) => {
    const { children, onReturn, onClose } = props;

    const isReturnButtonVisible = typeof onReturn !== "undefined";

    return (
        <StyledModalHeader>
            {isReturnButtonVisible ? <StyledButtonWrap>
                    <IconButton
                        dataAutomation="return-modal-button"
                        iconName="arrow-left"
                        iconSize="sm"
                        type="flat"
                        onClick={onReturn}
                    />
                </StyledButtonWrap> : null}

            {children}

            <StyledButtonWrap>
                <IconButton
                    dataAutomation="close-modal-button"
                    iconName="clear"
                    iconSize="sm"
                    type="flat"
                    onClick={onClose}
                />
            </StyledButtonWrap>
        </StyledModalHeader>
    );
};

export default ModalHeader;
